// Expo.jsx
import React, { useEffect, useMemo, useRef, useState } from "react";
import axios from "axios";
import "./Expo.scss";
import { customerService } from "../../services";
import { connect } from "react-redux";

function Expo({ profile }) {

    const customerLS = useMemo(() => {
        try {
            const raw = localStorage.getItem("customer");
            return raw ? JSON.parse(raw) : null;
        } catch {
            return null;
        }
    }, []);


    const searchParams = new URLSearchParams(window.location.search);
    const pageTypeRaw = (searchParams.get("type") || "pocket").toLowerCase();
    const pageType = ["pocket", "book", "abuddy", "bag", "agr", "academy"].includes(pageTypeRaw) ? pageTypeRaw : "pocket";
    const inputClass =
        pageTypeRaw === "agr" || pageTypeRaw === "academy"
            ? "expocAgrodeInput"
            : "expocodeInput";
    const [initDone, setInitDone] = useState(false);
    const [notFoundCustomer, setNotFoundCustomer] = useState(null); // null | true | false

    const [amwayNumber, setAmwayNumber] = useState(null);
    const [partyId, setPartyId] = useState(null);

    const [redeemCodeByType, setRedeemCodeByType] = useState(new Map());
    const [allowInput, setAllowInput] = useState(false);
    const [apiRedeemed, setApiRedeemed] = useState(false);

    const [codeDigits, setCodeDigits] = useState(["", "", "", ""]);
    const inputsRef = useRef([]);
    const [errorText, setErrorText] = useState("");

    const expectedCode = useMemo(() => redeemCodeByType.get(pageType) || "", [redeemCodeByType, pageType]);
    const code = useMemo(() => codeDigits.join(""), [codeDigits]);
    const isCodeComplete = useMemo(() => codeDigits.every((d) => d !== ""), [codeDigits]);

    const isValid = useMemo(() => {
        return isCodeComplete && expectedCode && code === expectedCode;
    }, [isCodeComplete, expectedCode, code]);

    const focusInput = (idx = 0) => {
        const el = inputsRef.current[idx];
        if (el && typeof el.focus === "function") el.focus();
    };


    const fetchStaff = async () => {
        const res = await axios.post(`${process.env.REACT_APP_API_URL}/customers/expo_staff`, {});
        const rows = Array.isArray(res.data) ? res.data : [];
        const map = new Map();

        rows.forEach((r) => {
            const clean = String(r.amwayNumber || "").replace(/\D/g, "");
            if (clean.length === 4) map.set(String(r.type).toLowerCase(), clean);
        });

        setRedeemCodeByType(map);
    };

    useEffect(() => {
        if (customerLS?.amwayNumber && !amwayNumber) {
            setAmwayNumber(customerLS.amwayNumber);
        }
        if (customerLS?.partyId && !partyId) {
            setPartyId(customerLS.partyId);
        }
    }, [customerLS, amwayNumber, partyId]);

    const expoPageRef = useRef(null);

    useEffect(() => {
        if (!initDone) return;
        if (!isCodeComplete) return;

        const el = expoPageRef.current;
        if (el) el.scrollTop = 0;
    }, [initDone, isCodeComplete]);

    const fetchCustomer = async () => {
        if (!profile?.userId) return;
        const c = await customerService.get(profile.userId);
        if (!c?.amwayNumber) {
            setNotFoundCustomer(true);
            return;
        }

        setAmwayNumber(c.amwayNumber);
        setPartyId(c.partyId);

        const res = await axios.post(`${process.env.REACT_APP_API_URL}/customers/expo`, {
            uid: c.uid,
            amwayNumber: c.amwayNumber,
            partyId: c.partyId,
            type: pageType,
        });

        const customer = Array.isArray(res.data?.customer) ? res.data.customer : [];
        const logs = Array.isArray(res.data?.customerLog) ? res.data.customerLog : [];

        const hasRight = customer.some((x) => String(x.type).toLowerCase() === pageType);
        const redeemed = logs.some((l) => String(l.type).toLowerCase() === pageType);

        setAllowInput(hasRight);
        setApiRedeemed(redeemed);

        // tri-state: ถ้าไม่มีสิทธิ์ -> notfound true, ถ้ามีสิทธิ์ -> false
        setNotFoundCustomer(!hasRight);
    };

    const handleKeyDown = (idx, e) => {
        if (e.key !== "Backspace") return;

        // ถ้ามีตัวเลขในช่องนี้ -> ลบตัวนี้
        if (codeDigits[idx]) {
            const next = [...codeDigits];
            next[idx] = "";
            setCodeDigits(next);
            return;
        }

        // ถ้าไม่มีตัวเลขในช่องนี้ -> ย้อนกลับไปช่องก่อนหน้า
        if (idx > 0) {
            const next = [...codeDigits];
            next[idx - 1] = "";
            setCodeDigits(next);
            focusInput(idx - 1);
        }
    };

    useEffect(() => {
        const img = new Image();
        img.src = "/images/expo/expo-loading.png";
    }, []);

    useEffect(() => {
        if (!profile?.userId) return;

        const init = async () => {
            try {
                await fetchStaff();
                await fetchCustomer();
            } finally {
                setInitDone(true);
                setTimeout(() => focusInput(0), 0);
            }
        };

        init();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [profile?.userId, pageType]);

    const handleDigitChange = (idx, e) => {
        const v = e.target.value.replace(/\D/g, "").slice(-1);
        const next = [...codeDigits];
        next[idx] = v;
        setCodeDigits(next);
        if (v && idx < 3) focusInput(idx + 1);
    };

    const clearAll = () => {
        setCodeDigits(["", "", "", ""]);
        setTimeout(() => focusInput(0), 0);
    };

    const handleEnter = async () => {
        if (apiRedeemed) return;
        if (!isCodeComplete) return;

        // กรอกครบแต่ไม่ตรง -> เคลียร์ทั้งหมด
        if (!isValid) {
            setErrorText("รหัสไม่ถูกต้อง");
            clearAll();
            return;
        }

        try {
            setErrorText("");
            await axios.post(`${process.env.REACT_APP_API_URL}/customers/expo_pass`, {
                uid: profile.userId,
                amwayNumber,
                partyId,
                type: pageType,
                code: code
            });

            setApiRedeemed(true);
        } catch (e) {
            setErrorText("เกิดข้อผิดพลาด กรุณาลองใหม่");
            clearAll();
        }
    };

    // ====== CLASS คุมภาพพื้นหลัง ======
    const stateClass = !initDone
        ? "state-loading"
        : notFoundCustomer === true
            ? "state-notfound"
            : apiRedeemed
                ? "state-redeemed"
                : isCodeComplete
                    ? "state-redeem"
                    : "state-base";

    if (!initDone) {
        return (
            <div className={`expoWrapper wr-${pageType}`}>
                <div ref={expoPageRef} className={`expoPage type-${pageType} state-loading`} />
            </div>
        );
    }

    return (
        <div className={`expoWrapper wr-${pageType}`}>
            <div ref={expoPageRef} className={`expoPage type-${pageType} ${stateClass}`}>
                {initDone && allowInput && !apiRedeemed && notFoundCustomer === false && (
                    <>
                        <div className="expocodePanel">
                            <div className="expocodeRow">
                                {codeDigits.map((d, i) => (
                                    <input
                                        key={i}
                                        ref={(el) => (inputsRef.current[i] = el)}
                                        className={inputClass}
                                        type="password"
                                        inputMode="numeric"
                                        pattern="[0-9]*"
                                        maxLength={1}
                                        value={d}
                                        onChange={(e) => handleDigitChange(i, e)}
                                        onKeyDown={(e) => handleKeyDown(i, e)}
                                    />
                                ))}
                            </div>
                        </div>

                        <div className={`expoenterHit ${isValid ? "ready" : ""}`} onClick={handleEnter} />
                    </>
                )}

                {initDone && errorText && <div className="expoerrorText">{errorText}</div>}
            </div>
        </div>
    );
}

export default connect((s) => ({ profile: s.profile }))(Expo);
